// import React, { useState, useEffect, useRef } from 'react';
// import { FaRobot, FaMicrophone, FaPaperPlane, FaTimes, FaSpinner } from 'react-icons/fa';
// import './aibot.css';

// export default function AIBotWidget({ isOpen, onClose }) {
//   const [messages, setMessages] = useState([{ role: 'assistant', content: 'Hi! I am Hanna. How can I help you scale today?' }]);
//   const [input, setInput] = useState('');
//   const [isListening, setIsListening] = useState(false);
//   const [isTyping, setIsTyping] = useState(false);
//   const scrollRef = useRef(null);

//   useEffect(() => { scrollRef.current?.scrollIntoView({ behavior: 'smooth' }); }, [messages]);
// const apiKey = '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';
//  console.log("Checking API Key:", apiKey ? "Key Loaded" : "KEY IS UNDEFINED");
//   const sendMessage = async (text) => {
//     if (!text.trim()) return;
//     const newMsgs = [...messages, { role: 'user', content: text }];
//     setMessages(newMsgs);
//     setInput('');
//     setIsTyping(true);

//     try {
//       const response = await fetch("https://api.groq.com/openai/v1/chat/completions", {
//         method: "POST",
//         headers:{
//   "Authorization": `Bearer ${apiKey}`,
//   "Content-Type": "application/json"
// },
//         body: JSON.stringify({
//           model: "llama-3.1-8b-instant",
//           messages: [
//             { role: "system", content: "You are Hanna, Cyfrowy.ai assistant. We provide business solutions powered by AI." },
//             ...newMsgs.map(m => ({ role: m.role, content: m.content }))
//           ]
//         })
//       });

//       const data = await response.json();

//       if (data.error) throw new Error(data.error.message);

//       setMessages([...newMsgs, { role: 'assistant', content: data.choices[0].message.content }]);
//     } catch (e) {
//       console.error("Groq API Error:", e);
//       setMessages([...newMsgs, { role: 'assistant', content: "I'm currently undergoing a quick sync. Please try again in a moment!" }]);
//     }
//     setIsTyping(false);
//   };

//   const startVoice = () => {
//     const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
//     const recognition = new SpeechRecognition();
//     recognition.onstart = () => setIsListening(true);
//     recognition.onend = () => setIsListening(false);
//     recognition.onresult = (e) => sendMessage(e.results[0][0].transcript);
//     recognition.start();
//   };

//   return (
//     <div className="bot-window">
//      <div className="bot-header">
//   <div className="bot-status">
//     <span className="online-dot"></span> Cyfrowy AI
//   </div>
//   <button onClick={onClose} className="close-btn">
//     <FaTimes size={14} />
//   </button>
// </div>
//       <div className="bot-messages">
//         {messages.map((m, i) => (
//           <div key={i} className={`msg ${m.role}`}>
//             <p>{m.content}</p>
//           </div>
//         ))}
//         {isTyping && <div className="msg assistant"><FaSpinner className="spin" /></div>}
//         <div ref={scrollRef} />
//       </div>
//       <div className="bot-input">
//         <button onClick={startVoice} className={isListening ? 'mic-active' : ''}><FaMicrophone /></button>
//         <input value={input} onChange={(e) => setInput(e.target.value)} onKeyPress={(e) => e.key === 'Enter' && sendMessage(input)} placeholder="Ask about our tools..." />
//         <button onClick={() => sendMessage(input)}><FaPaperPlane /></button>
//       </div>
//     </div>
//   );
// }

// ------------------------------- working good

// import React, { useState, useRef, useEffect } from 'react';
// import { FaRobot, FaMicrophone, FaPaperPlane, FaTimes, FaSpinner } from 'react-icons/fa';
// import './aibot.css';

// const SERVICES = [
//   { label: "Tele calling AI", info: "Automated engagement. $299/mo. Features: CRM Sync, Multi-language." },
//   { label: "Chat Genie AI", info: "Next-gen chatbot. $249/mo. Features: Sentiment Analysis, Auto-Context." },
//   { label: "Pricing Plans", info: "Starter: $99, Pro: $499, Enterprise: Custom." }
// ];

// export default function AIBotWidget({ isOpen, onClose }) {
//   const [messages, setMessages] = useState([{ role: 'assistant', content: 'Hi! I am Hanna. How can I help you today?' }]);
//   const [input, setInput] = useState('');
//   const [isTyping, setIsTyping] = useState(false);
//   const [isListening, setIsListening] = useState(false);
//   const scrollRef = useRef(null);

//   useEffect(() => { scrollRef.current?.scrollIntoView({ behavior: 'smooth' }); }, [messages]);
// const apiKey = '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';
//  console.log("Checking API Key:", apiKey ? "Key Loaded" : "KEY IS UNDEFINED");
//   const sendMessage = async (text) => {
//     if (!text.trim()) return;
//     const newMsgs = [...messages, { role: 'user', content: text }];
//     setMessages(newMsgs);
//     setInput('');
//     setIsTyping(true);

//     try {
//       const response = await fetch("https://api.groq.com/openai/v1/chat/completions", {
//         method: "POST",
//         headers: {
//           "Authorization": `Bearer ${apiKey}`,
//           "Content-Type": "application/json"
//         },
//         body: JSON.stringify({
//           model: "llama-3.1-8b-instant",
//           messages: [{ role: "system", content: "You are Hanna, Cyfrowy.ai assistant. Sell our tools: Tele calling AI ($299), Chat Genie AI ($249)." }, ...newMsgs.map(m => ({ role: m.role, content: m.content }))]
//         })
//       });
//       const data = await response.json();
//       setMessages(prev => [...prev, { role: 'assistant', content: data.choices[0].message.content }]);
//     } catch (e) { setMessages(prev => [...prev, { role: 'assistant', content: "I'm having trouble connecting. Please check your API Key." }]); }
//     setIsTyping(false);
//   };

//   const startVoice = () => {
//     const recognition = new (window.SpeechRecognition || window.webkitSpeechRecognition)();
//     recognition.onstart = () => setIsListening(true);
//     recognition.onend = () => setIsListening(false);
//     recognition.onresult = (e) => sendMessage(e.results[0][0].transcript);
//     recognition.start();
//   };

//   return (
//     <div className="bot-window">
//       <div className="bot-header">
//         <div className="bot-status"><span className="online-dot"></span> Cyfrowy AI</div>
//         <button onClick={onClose} className="close-btn"><FaTimes /></button>
//       </div>

//       <div className="bot-messages">
//         {messages.map((m, i) => <div key={i} className={`msg ${m.role}`}>{m.content}</div>)}

//         <div className="quick-replies">
//           {SERVICES.map((s, i) => (
//             <button key={i} onClick={() => {
//               setMessages(prev => [...prev, { role: 'user', content: s.label }, { role: 'assistant', content: s.info }]);
//             }} className="service-btn">{s.label}</button>
//           ))}
//         </div>

//         {isTyping && <div className="msg assistant"><FaSpinner className="spin" /></div>}
//         <div ref={scrollRef} />
//       </div>

//       <div className="bot-input">
//         <button onClick={startVoice} className={isListening ? 'mic-active' : ''}><FaMicrophone /></button>
//         <input value={input} onChange={(e) => setInput(e.target.value)} placeholder="Type or speak..." />
//         <button onClick={() => sendMessage(input)}><FaPaperPlane /></button>
//       </div>
//     </div>
//   );
// }

// ----------------------- new

// import React, { useState, useRef, useEffect } from 'react';
// import { FaRobot, FaMicrophone, FaPaperPlane, FaTimes, FaSpinner } from 'react-icons/fa';
// import './aibot.css';

// const AGENT_DATA = {
//   HR: ["HR Helpdesk", "Hiring Assistant", "Performance Review"],
//   Marketing: ["Content Creation", "Social Media Agent", "Ebook Generator"],
//   Sales: ["AI SDR Agent", "Phone Dialer", "Proposal Writer"],
//   Banking: ["KYC Compliance", "Fraud Detection", "Loan Origination"],
//   Insurance: ["Policy Underwriting", "Claims Processing", "Claims Analysis"],
//   Others: ["RFP Creation", "IT Helpdesk", "Cloud Cost Analyzer"]
// };

// export default function AIBotWidget({ isOpen, onClose }) {
//   const [messages, setMessages] = useState([{ role: 'assistant', content: 'Hi! I am Hanna. Which AI Agent service do you need?' }]);
//   const [input, setInput] = useState('');
//   const [step, setStep] = useState('CATEGORY'); // CATEGORY, AGENT, CHAT
//   const [context, setContext] = useState({ agent: '', history: [] });
//   const [isTyping, setIsTyping] = useState(false);
//   const [isListening, setIsListening] = useState(false);
//   const scrollRef = useRef(null);

//   useEffect(() => { scrollRef.current?.scrollIntoView({ behavior: 'smooth' }); }, [messages]);
// const apiKey = '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';
//  console.log("Checking API Key:", apiKey ? "Key Loaded" : "KEY IS UNDEFINED");
//   const handleAgentSelect = (agent) => {
//     setContext({ agent, history: [] });
//     setStep('CHAT');
//     setMessages(prev => [...prev, { role: 'user', content: agent }, { role: 'assistant', content: `Great! You selected the ${agent}. Tell me about your requirements, industry, and if you need a demo. I'm here to help!` }]);
//   };

//   const processAI = async (text) => {
//     if (!text.trim()) return;
//     const newMsgs = [...messages, { role: 'user', content: text }];
//     setMessages(newMsgs);
//     setInput('');
//     setIsTyping(true);

//     try {
//       const response = await fetch("https://api.groq.com/openai/v1/chat/completions", {
//         method: "POST",
//         headers: {
//           "Authorization": `Bearer ${apiKey}`,
//           "Content-Type": "application/json"
//         },
//         body: JSON.stringify({
//           model: "llama-3.1-8b-instant",
//           messages: [
//             { role: "system", content: `You are Hanna, a professional consultant for Cyfrowy.ai. Agent Context: ${context.agent}. Goal: Gather industry, specific needs (like Voice Gender/Inbound vs Outbound), and contact details (Name, Phone, Email) one by one. Be conversational.` },
//             ...newMsgs.map(m => ({ role: m.role, content: m.content }))
//           ]
//         })
//       });
//       const data = await response.json();
//       setMessages(prev => [...prev, { role: 'assistant', content: data.choices[0].message.content }]);
//     } catch (e) { setMessages(prev => [...prev, { role: 'assistant', content: "I'm having a technical sync. Try again?" }]); }
//     setIsTyping(false);
//   };

//   const startVoice = () => {
//     const rec = new (window.SpeechRecognition || window.webkitSpeechRecognition)();
//     rec.onstart = () => setIsListening(true);
//     rec.onend = () => setIsListening(false);
//     rec.onresult = (e) => processAI(e.results[0][0].transcript);
//     rec.start();
//   };

//   return (
//     <div className="bot-window">
//       <div className="bot-header">
//         <div className="bot-status"><span className="online-dot"></span> Hanna AI</div>
//         <button onClick={onClose} className="close-btn"><FaTimes size={14} /></button>
//       </div>

//       <div className="bot-messages">
//         {messages.map((m, i) => <div key={i} className={`msg ${m.role}`}>{m.content}</div>)}

//         {/* UI Navigation Flow */}
//         {step === 'CATEGORY' && (
//           <div className="quick-replies">{Object.keys(AGENT_DATA).map(cat => <button key={cat} onClick={() => setStep(cat)} className="service-btn">{cat}</button>)}</div>
//         )}
//         {Object.keys(AGENT_DATA).includes(step) && (
//           <div className="quick-replies">{AGENT_DATA[step].map(ag => <button key={ag} onClick={() => handleAgentSelect(ag)} className="service-btn">{ag}</button>)}</div>
//         )}

//         {isTyping && <div className="msg assistant"><FaSpinner className="spin" /></div>}
//         <div ref={scrollRef} />
//       </div>

//       <div className="bot-input">
//         <button onClick={startVoice} className={isListening ? 'mic-active' : ''}><FaMicrophone /></button>
//         <input value={input} onChange={(e) => setInput(e.target.value)} placeholder="Type or speak..." />
//         <button onClick={() => processAI(input)}><FaPaperPlane /></button>
//       </div>
//     </div>
//   );
// }

// ------------------------- test
import React, { useState, useRef, useEffect } from 'react';
import { FaRobot, FaMicrophone, FaPaperPlane, FaTimes, FaSpinner } from 'react-icons/fa';
import './aibot.css';


// Add this component at the top of your file
const PackageCard = ({ data }) => {
  const [name, price, features] = data.split('|').map(s => s.trim());
  return (
    <div className="pkg-card">
      <h4>{name}</h4>
      <div className="pkg-price">{price}</div>
      <ul>{features.split(',').map((f, i) => <li key={i}>✓ {f}</li>)}</ul>
    </div>
  );
};


const AGENT_KNOWLEDGE = {
  // HR
  "HR Helpdesk agent":
    "Objective: Automate employee queries. Features: 24/7 policy access, instant HR ticket resolution.",
  "ESAT Survey Agent":
    "Objective: Employee sentiment analysis. Features: Automated survey distribution, real-time engagement dashboard.",
  "AI Hiring Assistant":
    "Objective: Speed up recruitment. Features: Resume screening, interview scheduling, candidate ranking.",
  "Exit Interview Agent":
    "Objective: Retention insights. Features: Automated feedback collection, churn pattern analysis.",
  "AI Performance Review":
    "Objective: Appraisal automation. Features: Performance data synthesis, goal alignment tracking.",
  "Leave & Attendance Query Agent":
    "Objective: Time management. Features: Instant balance checks, automated leave approval workflow.",
  "AI L&D Agent":
    "Objective: Skill development. Features: Personalized learning paths, automated training reminders.",
  "Employee Onboarding Agent":
    "Objective: Seamless integration. Features: Digital paperwork, automated checklist tracking, culture onboarding.",
  "HR Policy Q&A Agent":
    "Objective: Policy clarity. Features: Context-aware policy search, regulatory compliance updates.",

  // Marketing
  "AEO/GEO Optimizer Agent":
    "Objective: Search visibility. Features: AI-driven SEO ranking, geo-targeted content optimization.",
  "Competitor Marketing Tracker":
    "Objective: Market intelligence. Features: Real-time competitor monitoring, ad spend analysis.",
  "AI Internal Communication Agent":
    "Objective: Company alignment. Features: Newsletter automation, cross-departmental update synthesis.",
  "ABM Agent":
    "Objective: Target account growth. Features: Personalized account mapping, high-value lead identification.",
  "Content Distribution Agent":
    "Objective: Omnichannel reach. Features: Multi-platform posting, scheduling, and engagement tracking.",
  "AI Webinar Agent":
    "Objective: Lead generation. Features: Automated webinar registration, Q&A synthesis, post-event nurturing.",
  "AI Content Creation Agent":
    "Objective: Content scale. Features: Blog/Copy generation, brand voice consistency, SEO integration.",
  "Social Media Agent":
    "Objective: Brand growth. Features: Sentiment analysis, automated engagement, trend identification.",
  "Ebook Generator Agent":
    "Objective: Authority building. Features: Automated content structuring, professional layout generation.",

  // Sales
  "AI SDR Agent":
    "Objective: Sales outreach. Features: LinkedIn automation, lead scraping, custom outreach sequences.",
  "Prospect Research Agent":
    "Objective: Lead insight. Features: Automated background research, buying intent analysis.",
  "Linkedin Outreach Agent":
    "Objective: Network growth. Features: Personalized connection requests, automated follow-ups.",
  "Lead Enrichment Agent":
    "Objective: Data accuracy. Features: Real-time contact verification, CRM data enhancement.",
  "AI Phone Dialer":
    "Objective: Automated calling. Features: Real-time sentiment analysis, CRM logging, multi-language.",
  "AI Proposal Writer Agent":
    "Objective: Close deals faster. Features: Dynamic quote generation, compliance checking.",
  "AI Sales Coach":
    "Objective: Performance optimization. Features: Call recording analysis, talk-track improvement.",
  "AI Deal Nurturer":
    "Objective: Pipeline management. Features: Predictive lead scoring, automated follow-up scheduling.",
  "Meeting prep Agent":
    "Objective: High-value meetings. Features: Automated meeting brief creation, prospect data synthesis.",

  // Support
  "AI Cross Channel Support":
    "Objective: Unified helpdesk. Features: Multi-platform (Email/Chat/Social) integration.",
  "CRM Case Generator":
    "Objective: Support efficiency. Features: Automated ticket creation from support interactions.",
  "Email Triage Agent":
    "Objective: Inbox zero. Features: Email classification, priority routing, automated drafts.",
  "Conversational Support Agent":
    "Objective: Customer satisfaction. Features: Contextual resolution, 24/7 natural language support.",
  "AI Phone Support Agent":
    "Objective: Voice-based assistance. Features: Automated voice resolution, IVR deflection.",
  "Support Interaction Agent":
    "Objective: Resolution speed. Features: Real-time knowledge base retrieval.",

  // Banking
  "KYC Compliance agent":
    "Objective: Regulatory safety. Features: Automated ID verification, real-time fraud monitoring.",
  "Fraud Detection Agent":
    "Objective: Secure banking. Features: Real-time transaction pattern anomaly detection.",
  "Customer Onboarding":
    "Objective: Rapid banking access. Features: Digital KYC, automated account setup.",
  "AI Loan Origination":
    "Objective: Credit efficiency. Features: Instant risk scoring, automated document verification.",
  "Invoice Payment Agent":
    "Objective: Transaction speed. Features: Smart invoice scanning, automated payment scheduling.",
  "Real-Time Payment agent":
    "Objective: Payment processing. Features: Instant verification, compliance checks.",
  "Regulatory Monitoring":
    "Objective: Law compliance. Features: Automated legislative tracking, risk assessment.",
  "AML Agent":
    "Objective: Anti-money laundering. Features: Pattern analysis, suspicious activity report automation.",
  "AI Loan Servicing":
    "Objective: Debt management. Features: Automated repayment reminders, account status updates.",

  // Insurance
  "Regulatory Compliance Audit":
    "Objective: Safety & Law. Features: Automated audit trails, document compliance checks.",
  "Policy Underwriting Assistant":
    "Objective: Risk assessment. Features: Automated data analysis, policy fit modeling.",
  "Partner Quality Assurance Audit Agent":
    "Objective: Quality control. Features: Partner performance monitoring, automated audits.",
  "Claims Processing Agent":
    "Objective: Speed of claims. Features: Instant claim verification, payout estimation.",
  "Document Extraction for Litigation Agent":
    "Objective: Legal support. Features: Automated keyword extraction, case summary generation.",
  "Policy Underwriting support Agent":
    "Objective: Policy management. Features: Automated risk documentation, client profile analysis.",
  "Partner QA Simulation Agent":
    "Objective: Simulation testing. Features: QA scenario modeling, risk prediction.",
  "Claims Analysis Agent":
    "Objective: Fraud & Logic. Features: Anomaly detection in claims, data-driven payout logic.",

  // Others
  "RFP Creation Agent":
    "Objective: Business winning. Features: Automated proposal formatting, compliance checking.",
  "Investment Memo Generator Agent":
    "Objective: Decision support. Features: Automated financial data visualization, summary generation.",
  "IT Helpdesk Agent":
    "Objective: System reliability. Features: Automated hardware/software troubleshooting.",
  "Demand Forecasting Agent":
    "Objective: Resource planning. Features: AI-driven predictive modeling, trend analysis.",
  "AI SRE Agent":
    "Objective: System uptime. Features: Incident response automation, anomaly alerting.",
  "Startup Evaluation Agent":
    "Objective: Due diligence. Features: Market analysis, risk scoring, growth projection.",
  "Cloud Cost Analyzer Agent":
    "Objective: Budgeting. Features: Real-time spend optimization, resource usage prediction.",
  "Email Triage agent":
    "Objective: Inbox efficiency. Features: Urgent/General email sorting, auto-respond templates.",
};

export default function AIBotWidget({ isOpen, onClose }) {
  const [messages, setMessages] = useState([{ role: 'assistant', content: 'Hi! I am Hanna, your AI Consultant. How can I help you scale today? [MENU: HR Agents, Sales Agents, Banking Agents, Insurance Agents, Others]' }]);
  const [input, setInput] = useState('');
  const [isTyping, setIsTyping] = useState(false);
  const [isListening, setIsListening] = useState(false);
  const scrollRef = useRef(null);

  useEffect(() => { scrollRef.current?.scrollIntoView({ behavior: 'smooth' }); }, [messages]);
const apiKey = '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';
 console.log("Checking API Key:", apiKey ? "Key Loaded" : "KEY IS UNDEFINED");
  const processAI = async (text) => {
    if (!text.trim()) return;
    const newMsgs = [...messages, { role: 'user', content: text }];
    setMessages(newMsgs);
    setInput('');
    setIsTyping(true);

    try {
      const response = await fetch("https://api.groq.com/openai/v1/chat/completions", {
        method: "POST",
        headers: { "Authorization": `Bearer ${apiKey}`, "Content-Type": "application/json" },
        body: JSON.stringify({
          model: "llama-3.1-8b-instant",
          messages: [{ 
            role: "system", 
            content: `You are Hanna, a Senior Consultant for Cyfrowy.ai.
            KNOWLEDGE BASE: ${JSON.stringify(AGENT_KNOWLEDGE)}.
            RULES:
            1. Keep responses under 30 words, be concise, and to the point, never exceed 30 words.
            2. If user needs service and packages, show specific options using [MENU: Option1, Option2].
            3. Ask ONE question at a time (like what industry, then demo need, then contact details, like view the package detailes).
            4. If user selects a service, use AGENT_KNOWLEDGE to explain it briefly.
            
            5. Always collect Name, Email, and Phone one by one.` 
          }, ...newMsgs.map(m => ({ role: m.role, content: m.content }))]
        })
      });
      const data = await response.json();
      setMessages(prev => [...prev, { role: 'assistant', content: data.choices[0].message.content }]);
    } catch (e) { setMessages(prev => [...prev, { role: 'assistant', content: "Technical sync issue. Please try again." }]); }
    setIsTyping(false);
  };

  const startVoice = () => {
    const rec = new (window.SpeechRecognition || window.webkitSpeechRecognition)();
    rec.onstart = () => setIsListening(true);
    rec.onend = () => setIsListening(false);
    rec.onresult = (e) => processAI(e.results[0][0].transcript);
    rec.start();
  };

  const renderContent = (text) => {
    if (text.includes("[PACKAGE:")) {
    const pkgData = text.split("[PACKAGE:")[1].replace("]", "");
    return <PackageCard data={pkgData} />;
  }
  
    const parts = text.split("[MENU:");
    const message = parts[0];
    const menuItems = parts[1] ? parts[1].replace(']', '').split(',').map(s => s.trim()) : [];
    
    return (
      <>
        <p>{message}</p>
        <div className="quick-replies">
          {menuItems.map((item, i) => (
            <button key={i} onClick={() => processAI(item)} className="service-btn">{item}</button>
          ))}
        </div>
      </>
    );
  };

  return (
    <div className="bot-window">
      <div className="bot-header">
        <span>Hanna AI Consultant</span>
        <button onClick={onClose} className="close-btn"><FaTimes size={14}/></button>
      </div>
      
      <div className="bot-messages">
        {messages.map((m, i) => (
          <div key={i} className={`msg ${m.role}`}>
            {m.role === 'assistant' ? renderContent(m.content) : m.content}
          </div>
        ))}
        {isTyping && <div className="msg assistant"><FaSpinner className="spin" /></div>}
        <div ref={scrollRef} />
      </div>

      <div className="bot-input">
        <button onClick={startVoice} className={isListening ? 'mic-active' : ''}><FaMicrophone /></button>
        <input value={input} onChange={(e) => setInput(e.target.value)} onKeyPress={(e) => e.key === 'Enter' && processAI(input)} placeholder="Type/Speak..." />
        <button onClick={() => processAI(input)}><FaPaperPlane /></button>
      </div>
    </div>
  );
}

// ----------- test 2

// import React, { useState, useRef, useEffect } from "react";
// import {
//   FaRobot,
//   FaMicrophone,
//   FaPaperPlane,
//   FaTimes,
//   FaSpinner,
// } from "react-icons/fa";
// import "./aibot.css";

// // 1. The Expert Knowledge Base
// const AGENT_KNOWLEDGE = {
//   // HR
//   "HR Helpdesk agent":
//     "Objective: Automate employee queries. Features: 24/7 policy access, instant HR ticket resolution.",
//   "ESAT Survey Agent":
//     "Objective: Employee sentiment analysis. Features: Automated survey distribution, real-time engagement dashboard.",
//   "AI Hiring Assistant":
//     "Objective: Speed up recruitment. Features: Resume screening, interview scheduling, candidate ranking.",
//   "Exit Interview Agent":
//     "Objective: Retention insights. Features: Automated feedback collection, churn pattern analysis.",
//   "AI Performance Review":
//     "Objective: Appraisal automation. Features: Performance data synthesis, goal alignment tracking.",
//   "Leave & Attendance Query Agent":
//     "Objective: Time management. Features: Instant balance checks, automated leave approval workflow.",
//   "AI L&D Agent":
//     "Objective: Skill development. Features: Personalized learning paths, automated training reminders.",
//   "Employee Onboarding Agent":
//     "Objective: Seamless integration. Features: Digital paperwork, automated checklist tracking, culture onboarding.",
//   "HR Policy Q&A Agent":
//     "Objective: Policy clarity. Features: Context-aware policy search, regulatory compliance updates.",

//   // Marketing
//   "AEO/GEO Optimizer Agent":
//     "Objective: Search visibility. Features: AI-driven SEO ranking, geo-targeted content optimization.",
//   "Competitor Marketing Tracker":
//     "Objective: Market intelligence. Features: Real-time competitor monitoring, ad spend analysis.",
//   "AI Internal Communication Agent":
//     "Objective: Company alignment. Features: Newsletter automation, cross-departmental update synthesis.",
//   "ABM Agent":
//     "Objective: Target account growth. Features: Personalized account mapping, high-value lead identification.",
//   "Content Distribution Agent":
//     "Objective: Omnichannel reach. Features: Multi-platform posting, scheduling, and engagement tracking.",
//   "AI Webinar Agent":
//     "Objective: Lead generation. Features: Automated webinar registration, Q&A synthesis, post-event nurturing.",
//   "AI Content Creation Agent":
//     "Objective: Content scale. Features: Blog/Copy generation, brand voice consistency, SEO integration.",
//   "Social Media Agent":
//     "Objective: Brand growth. Features: Sentiment analysis, automated engagement, trend identification.",
//   "Ebook Generator Agent":
//     "Objective: Authority building. Features: Automated content structuring, professional layout generation.",

//   // Sales
//   "AI SDR Agent":
//     "Objective: Sales outreach. Features: LinkedIn automation, lead scraping, custom outreach sequences.",
//   "Prospect Research Agent":
//     "Objective: Lead insight. Features: Automated background research, buying intent analysis.",
//   "Linkedin Outreach Agent":
//     "Objective: Network growth. Features: Personalized connection requests, automated follow-ups.",
//   "Lead Enrichment Agent":
//     "Objective: Data accuracy. Features: Real-time contact verification, CRM data enhancement.",
//   "AI Phone Dialer":
//     "Objective: Automated calling. Features: Real-time sentiment analysis, CRM logging, multi-language.",
//   "AI Proposal Writer Agent":
//     "Objective: Close deals faster. Features: Dynamic quote generation, compliance checking.",
//   "AI Sales Coach":
//     "Objective: Performance optimization. Features: Call recording analysis, talk-track improvement.",
//   "AI Deal Nurturer":
//     "Objective: Pipeline management. Features: Predictive lead scoring, automated follow-up scheduling.",
//   "Meeting prep Agent":
//     "Objective: High-value meetings. Features: Automated meeting brief creation, prospect data synthesis.",

//   // Support
//   "AI Cross Channel Support":
//     "Objective: Unified helpdesk. Features: Multi-platform (Email/Chat/Social) integration.",
//   "CRM Case Generator":
//     "Objective: Support efficiency. Features: Automated ticket creation from support interactions.",
//   "Email Triage Agent":
//     "Objective: Inbox zero. Features: Email classification, priority routing, automated drafts.",
//   "Conversational Support Agent":
//     "Objective: Customer satisfaction. Features: Contextual resolution, 24/7 natural language support.",
//   "AI Phone Support Agent":
//     "Objective: Voice-based assistance. Features: Automated voice resolution, IVR deflection.",
//   "Support Interaction Agent":
//     "Objective: Resolution speed. Features: Real-time knowledge base retrieval.",

//   // Banking
//   "KYC Compliance agent":
//     "Objective: Regulatory safety. Features: Automated ID verification, real-time fraud monitoring.",
//   "Fraud Detection Agent":
//     "Objective: Secure banking. Features: Real-time transaction pattern anomaly detection.",
//   "Customer Onboarding":
//     "Objective: Rapid banking access. Features: Digital KYC, automated account setup.",
//   "AI Loan Origination":
//     "Objective: Credit efficiency. Features: Instant risk scoring, automated document verification.",
//   "Invoice Payment Agent":
//     "Objective: Transaction speed. Features: Smart invoice scanning, automated payment scheduling.",
//   "Real-Time Payment agent":
//     "Objective: Payment processing. Features: Instant verification, compliance checks.",
//   "Regulatory Monitoring":
//     "Objective: Law compliance. Features: Automated legislative tracking, risk assessment.",
//   "AML Agent":
//     "Objective: Anti-money laundering. Features: Pattern analysis, suspicious activity report automation.",
//   "AI Loan Servicing":
//     "Objective: Debt management. Features: Automated repayment reminders, account status updates.",

//   // Insurance
//   "Regulatory Compliance Audit":
//     "Objective: Safety & Law. Features: Automated audit trails, document compliance checks.",
//   "Policy Underwriting Assistant":
//     "Objective: Risk assessment. Features: Automated data analysis, policy fit modeling.",
//   "Partner Quality Assurance Audit Agent":
//     "Objective: Quality control. Features: Partner performance monitoring, automated audits.",
//   "Claims Processing Agent":
//     "Objective: Speed of claims. Features: Instant claim verification, payout estimation.",
//   "Document Extraction for Litigation Agent":
//     "Objective: Legal support. Features: Automated keyword extraction, case summary generation.",
//   "Policy Underwriting support Agent":
//     "Objective: Policy management. Features: Automated risk documentation, client profile analysis.",
//   "Partner QA Simulation Agent":
//     "Objective: Simulation testing. Features: QA scenario modeling, risk prediction.",
//   "Claims Analysis Agent":
//     "Objective: Fraud & Logic. Features: Anomaly detection in claims, data-driven payout logic.",

//   // Others
//   "RFP Creation Agent":
//     "Objective: Business winning. Features: Automated proposal formatting, compliance checking.",
//   "Investment Memo Generator Agent":
//     "Objective: Decision support. Features: Automated financial data visualization, summary generation.",
//   "IT Helpdesk Agent":
//     "Objective: System reliability. Features: Automated hardware/software troubleshooting.",
//   "Demand Forecasting Agent":
//     "Objective: Resource planning. Features: AI-driven predictive modeling, trend analysis.",
//   "AI SRE Agent":
//     "Objective: System uptime. Features: Incident response automation, anomaly alerting.",
//   "Startup Evaluation Agent":
//     "Objective: Due diligence. Features: Market analysis, risk scoring, growth projection.",
//   "Cloud Cost Analyzer Agent":
//     "Objective: Budgeting. Features: Real-time spend optimization, resource usage prediction.",
//   "Email Triage agent":
//     "Objective: Inbox efficiency. Features: Urgent/General email sorting, auto-respond templates.",
// };

// const AGENT_DATA = {
//   HR: ["HR Helpdesk", "Hiring Assistant", "Performance Review"],
//   Sales: ["AI SDR Agent", "Phone Dialer", "Proposal Writer"],
//   Banking: ["KYC Compliance", "Fraud Detection", "Loan Origination"],
//   More: ["Marketing", "Support", " Insurance", "Others"],
// };

// export default function AIBotWidget({ isOpen, onClose }) {
//   const [messages, setMessages] = useState([
//     {
//       role: "assistant",
//       content:
//         "Hi! I am Hanna, your AI Consultant. I can help you deploy specialized AI agents. What business challenge are you looking to solve?",
//     },
//   ]);
//   const [input, setInput] = useState("");
//   const [step, setStep] = useState("CATEGORY");
//   const [context, setContext] = useState({ agent: "" });
//   const [isTyping, setIsTyping] = useState(false);
//   const scrollRef = useRef(null);

//   useEffect(() => {
//     scrollRef.current?.scrollIntoView({ behavior: "smooth" });
//   }, [messages]);
//   const apiKey = "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";
//   console.log("Checking API Key:", apiKey ? "Key Loaded" : "KEY IS UNDEFINED");
//   const handleAgentSelect = (agent) => {
//     setContext({ agent });
//     setStep("CHAT");
//     const info =
//       AGENT_KNOWLEDGE[agent] || "This is a premium AI agent solution.";
//     setMessages((prev) => [
//       ...prev,
//       { role: "user", content: agent },
//       {
//         role: "assistant",
//         content: `Great choice! ${agent}. ${info}. To help me suggest the best package, could you tell me a bit about your industry and business goals?`,
//       },
//     ]);
//   };

//   const processAI = async (text) => {
//     if (!text.trim()) return;
//     const newMsgs = [...messages, { role: "user", content: text }];
//     setMessages(newMsgs);
//     setInput("");
//     setIsTyping(true);

//     try {
//       const response = await fetch(
//         "https://api.groq.com/openai/v1/chat/completions",
//         {
//           method: "POST",
//           headers: {
//             Authorization: `Bearer ${apiKey}`,
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             model: "llama-3.1-8b-instant",
//             messages: [
//               {
//                 role: "system",
//                 content: `You are Hanna, a Senior AI Consultant at Cyfrowy.ai. 
//             CONTEXT: User is interested in: ${context.agent || "General Inquiry"}. 
//             KNOWLEDGE BASE: ${JSON.stringify(AGENT_KNOWLEDGE)}.
//             Follow these rules:
// 1. When you offer services, list them and end your message with: [MENU: Service 1, Service 2, Service 3].
// 2. Answer all questions professionally.
// 3. Collect Name, Email, and Phone.
// 4. If the user picks an agent, explain it based on this knowledge: ${JSON.stringify(AGENT_KNOWLEDGE)}.
// 5. All answers should not exceed 100 words. Be concise and to the point.
//             INSTRUCTIONS: 
//             1. If user asks for services, refer them to the menu.
//             2. If user selected an agent, explain its benefits based on the Knowledge Base.
//             3. Collect Name, Email, and Phone number professionally.
//             4. Tone: Senior Consultant, helpful, and concise.
//             5. Always ask one question at a time and wait for user response before asking the next question.
//             6. Use a conversational style, but maintain professionalism.
//             7. If user input is unrelated, politely steer them back to discussing AI solutions for their business needs.
//             8. Answers should be based on the AGENT_KNOWLEDGE provided.
//             9. All answers should not exceed 100 words. Be concise and to the point.
//             10. Never forget to ask for contact details if the user shows interest in any agent.
//             11. If user asks for pricing, provide a general range based on the agent category (e.g., "Our agents typically range from $199 to $499 per month, depending on the complexity and features you need.").`,
//               },
//               ...newMsgs.map((m) => ({ role: m.role, content: m.content })),
//             ],
//           }),
//         },
//       );
//       const data = await response.json();
//       setMessages((prev) => [
//         ...prev,
//         { role: "assistant", content: data.choices[0].message.content },
//       ]);
//     } catch (e) {
//       setMessages((prev) => [
//         ...prev,
//         {
//           role: "assistant",
//           content: "I'm having a technical sync. Please try again.",
//         },
//       ]);
//     }
//     setIsTyping(false);
//   };

//   // Add this helper function inside AIBotWidget
//   const renderContent = (text) => {
//     const parts = text.split("[MENU:");
//     const message = parts[0];
//     const menuItems = parts[1]
//       ? parts[1]
//           .replace("]", "")
//           .split(",")
//           .map((s) => s.trim())
//       : [];

//     return (
//       <>
//         <p>{message}</p>
//         {menuItems.length > 0 && (
//           <div className="quick-replies">
//             {menuItems.map((item, i) => (
//               <button
//                 key={i}
//                 onClick={() => processAI(item)}
//                 className="service-btn"
//               >
//                 {item}
//               </button>
//             ))}
//           </div>
//         )}
//       </>
//     );
//   };

//   return (
//     <div className="bot-window">
//       <div className="bot-header">
//         <span>Hanna AI Consultant</span>
//         <button onClick={onClose} className="close-btn">
//           <FaTimes />
//         </button>
//       </div>
//       {/* <div className="bot-messages">
//         {messages.map((m, i) => <div key={i} className={`msg ${m.role}`}>{m.content}</div>)}
        
//         {step === 'CATEGORY' && (
//           <div className="quick-replies">{Object.keys(AGENT_DATA).map(cat => <button key={cat} onClick={() => setStep(cat)} className="service-btn">{cat}</button>)}</div>
//         )}
//         {Object.keys(AGENT_DATA).includes(step) && (
//           <div className="quick-replies">{AGENT_DATA[step].map(ag => <button key={ag} onClick={() => handleAgentSelect(ag)} className="service-btn">{ag}</button>)}</div>
//         )}
        
//         {isTyping && <div className="msg assistant"><FaSpinner className="spin" /></div>}
//         <div ref={scrollRef} />
//       </div> */}

//       <div className="bot-messages">
//         {messages.map((m, i) => (
//           <div key={i} className={`msg ${m.role}`}>
//             {m.role === "assistant" ? renderContent(m.content) : m.content}
//           </div>
//         ))}
//         {isTyping && (
//           <div className="msg assistant">
//             <FaSpinner className="spin" />
//           </div>
//         )}
//         <div ref={scrollRef} />
//       </div>

//       <div className="bot-input">
//         <input
//           value={input}
//           onChange={(e) => setInput(e.target.value)}
//           placeholder="Type your query..."
//         />
//         <button onClick={() => processAI(input)}>
//           <FaPaperPlane />
//         </button>
//       </div>
//     </div>
//   );
// }
